/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Success_CreatedInputs */

const he_posts_success_created = /** @type {(inputs: Posts_Success_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פוסט נוצר`)
};

const en_posts_success_created = /** @type {(inputs: Posts_Success_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post created`)
};

/**
* | output |
* | --- |
* | "Post created" |
*
* @param {Posts_Success_CreatedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const posts_success_created = /** @type {((inputs?: Posts_Success_CreatedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Success_CreatedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_success_created(inputs)
	return en_posts_success_created(inputs)
});